define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function RiqGroupModelServiceModule(aoflModules) {
  'use strict';
  var storeService = aoflModules.store;

  /**
   * Handles class roster api
   * @function riqGroupModelService
   * @param {Object} riqApiService - riqApiService
   * @param {Object} riqAnalyticsService - riqAnalyticsService
   * */
  var riqGroupModelService = function(riqApiService, riqAnalyticsService) {
    var _this = this;

    riqApiService.setApiEndpoints({
      getGroup: 'group_get',
      updateGroup: 'group_update',
      importABCmouseRoster: 'teacher_get_roster',
      addGroupProfile: 'group_add_profile',
      onboardingAddProfile: 'onboarding_add_profile',
      onboardingGroupUpdate: 'onboarding_group_update',
      updateProfile: 'profile_update',
      updateProfileMultiple: 'profile_update_multiple',
      updateAllGroupProfiles: 'group_update_all_profiles',
      removeProfileFromGroup: 'group_remove_profile',
      removeProfilesFromGroup: 'group_remove_profiles',
      submitRedeemCode: 'code_redeem'
    });

    var getGroup = function getGroup(profileDetails, _cache) {
      var state = storeService.getState();
      var groupUuid = state.user.groupUuid;
      var profileDetailsOptions = profileDetails || [
        'name',
        'last_name',
        'avatar'
      ];

      // available options => 'name', 'avatar', 'invitation_status',
      // 'contact_email', 'inactive', 'profile_grade_level', 'created_date',
      // 'active_reading_level', 'active_reading_level_type', 'teacher_school',
      // 'teacher_role', 'redeem_code', 'csv_imported'
      return riqApiService
        .get(
          'getGroup',
          {
            groupUuid: groupUuid,
            profileDetails: profileDetailsOptions,
            includeOwner: true
          },
          _cache
        )
        .then(function(payload) {
          return payload.group;
        })
        .catch(function(error) {
          throw error;
        });
    };

    var updateGroup = function updateGroup(groupDetails, _cache, onboarding) {
      var state = storeService.getState();
      var groupUuid = state.user.groupUuid;
      const endpoint = onboarding ? 'onboardingGroupUpdate' : 'updateGroup';
      return riqApiService.get(
        endpoint,
        {
          groupUuid: groupUuid,
          groupDetails: groupDetails,
          includeOwner: true
        },
        _cache
      );
    };

    var importABCmouseRoster = function importABCmouseRoster() {
      return riqApiService.get('importABCmouseRoster');
    };

    var addGroupProfile = function addGroupProfile(child, onboarding = false) {
      const endpoint = onboarding ? 'onboardingAddProfile' : 'addGroupProfile';
      var state = storeService.getState();
      var groupUuid = state.user.groupUuid;
      return riqApiService
        .get(
          endpoint,
          {
            groupUuid: groupUuid,
            profileDetails: child
          },
          false
        )
        .then(function(payload) {
          riqAnalyticsService.enqueueEvent({
            eventType: 'com.aofl.readingiq.profile.create',
            payload: payload.tracking
          });
          return payload;
        });
    };

    var updateGroupProfile = function updateGroupProfile(child) {
      var state = storeService.getState();
      var groupUuid = state.user.groupUuid;
      var profileUuid = state.studentForm.profileUuid;
      return riqApiService.get('updateProfile', {
        groupUuid: groupUuid,
        profileUuid: profileUuid,
        profileDetails: child
      });
    };

    var updateProfile = function updateProfile(data) {
      return riqApiService
        .userGet('updateProfile', data, false)
        .then(function(payload) {
          riqAnalyticsService.enqueueEvent({
            eventType: 'com.aofl.readingiq.profile.update',
            payload: payload.tracking
          });
          return payload;
        });
    };

    var updateProfileMultiple = function updateProfileMultiple(data) {
      return riqApiService.userGet('updateProfileMultiple', data, false);
    };

    var updateAllGroupProfiles = function updateAllGroupProfiles(
      profileDetails
    ) {
      var state = storeService.getState();
      var groupUuid = state.user.groupUuid;
      return riqApiService.get('updateAllGroupProfiles', {
        groupUuid: groupUuid,
        profileDetails: profileDetails,
        includeOwner: true
      });
    };

    var updateGroupData = function updateGroupData(groupLevelType) {
      var state = storeService.getState();
      var groupUuid = state.user.groupUuid;
      return riqApiService.post('updateGroup', {
        groupUuid: groupUuid,
        groupDetails: {
          groupLevelType
        },
        includeOwner: true
      });
    };

    var removeProfileFromGroup = function removeProfileFromGroup(
      profileUuid,
      groupUuid
    ) {
      return riqApiService.get('removeProfileFromGroup', {
        profileUuid: profileUuid,
        groupUuid: groupUuid
      });
    };

    var removeProfilesFromGroup = function removeProfilesFromGroup(
      profileUuids,
      groupUuid
    ) {
      return riqApiService.get('removeProfilesFromGroup', {
        profileUuids: profileUuids,
        groupUuid: groupUuid
      });
    };

    var submitRedeemCode = function submitRedeemCode(studentId, redeemCode) {
      return riqApiService.get('submitRedeemCode', {
        profileUuid: studentId,
        code: redeemCode
      });
    };

    var getGroupOwner = function getGroupOwner(profiles) {
      return profiles.filter(function(profile) {
        return profile.isGroupOwner;
      })[0];
    };

    _this.getGroup = getGroup;
    _this.updateGroup = updateGroup;
    _this.importABCmouseRoster = importABCmouseRoster;
    _this.addGroupProfile = addGroupProfile;
    _this.updateGroupProfile = updateGroupProfile;
    _this.updateProfile = updateProfile;
    _this.updateProfileMultiple = updateProfileMultiple;
    _this.updateAllGroupProfiles = updateAllGroupProfiles;
    _this.updateGroupData = updateGroupData;
    _this.removeProfileFromGroup = removeProfileFromGroup;
    _this.removeProfilesFromGroup = removeProfilesFromGroup;
    _this.submitRedeemCode = submitRedeemCode;
    _this.getGroupOwner = getGroupOwner;
  };

  return riqGroupModelService;
});
